export default __webpack_public_path__ + "static/media/02.53e5e561.jpg";